// @flow
import type { PromoCampaign, PromoRequest } from '../constants';
import { INFLUENCER_SETTING_PREFIX, INFLUENCER_SLUG, INFLUENCER_VIEW, PREVIEW_PARAM, PROMO_PARAM } from '../constants';
import { veranoplus } from './veranoplus';
import { blackplus } from './blackplus';

/**
 * Las campañas que la landing sabe pintar. Cada una vive en su ficha; añadir una promoción es
 * escribir la suya y registrarla aquí. Varias pueden convivir: la URL decide cuál se pide y el
 * ajuste de cada una decide si está viva.
 */
export const CAMPAIGNS: Array<PromoCampaign> = [veranoplus, blackplus];

/**
 * Slugs que no pueden ser de un influencer: los de las campañas de código, que se resuelven antes, y
 * los de campañas que ya no estén registradas pero cuyo enlace siga por ahí. dashboard2 no deja dar
 * de alta ninguno (front-dashboard, scenes/Settings/InfluencerLandings, misma lista).
 */
export const RESERVED_SLUGS: Array<string> = ['blackplus', 'veranoplus', ...CAMPAIGNS.map(campaign => campaign.id)];

/**
 * La campaña que pide una URL, o null si no pide ninguna.
 *
 * El valor se normaliza porque estas URLs se escriben a mano en anuncios, emails y hojas de cálculo:
 * un `?promo=Blackplus` o un espacio pegado no pueden dejar la landing sin salir y sin avisar. Lo
 * que no se toca es el nombre del parámetro, que sí es exacto.
 *
 * Si no es una campaña de código y tiene forma de slug, es la landing de un influencer: se devuelve su
 * ficha sin saber todavía si existe, porque eso lo dice su ajuste. Por eso el formato se mira aquí: un
 * valor que no lo cumple no cuesta ninguna petición.
 *
 * @param params Parámetros de la URL
 */
export const getPromoCampaign = (params: Object = {}): PromoRequest | null => {
  const id = String(params[PROMO_PARAM] ?? '')
    .trim()
    .toLowerCase();
  const campaign = CAMPAIGNS.find(item => item.id === id);

  if (campaign) return campaign;
  if (!INFLUENCER_SLUG.test(id) || RESERVED_SLUGS.includes(id)) return null;

  return {
    id,
    dynamic: true,
    view: INFLUENCER_VIEW,
    setting: `${INFLUENCER_SETTING_PREFIX}${id}`,
    ga4: { label: `influencer-${id}`, pageId: `influencer-${id}` },
    preview: params[PREVIEW_PARAM] === '1'
  };
};
